module.exports = __webpack_public_path__ + "static/media/bbva.0751cadd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bbva.jpg
// module id = 487
// module chunks = 0 1 2